import { Button, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
const axios = require("axios").default;

// function createData(id, service_name, mrp) {
//   return { id, service_name, mrp };
// }

// const row = [
//   createData(1, "Service 1", 500),
//   createData(3, "Service 3", 1000),
//   createData(4, "Service 4", 2000),
//   createData(2, "Service 2", 500),
//   createData(9, "Service 9", 1500),
// ];
//

const ServicePriceList = () => {
  const dispatch = useDispatch();
  // state management
  const [serviceList, setServiceList] = useState([]);
  // state management end
  // Method management
  const handleListItemChange = (value, index, filed_name) => {
    // console.log("handleMrpValueChange", value, index);
    const tempServiceList = [...serviceList];
    tempServiceList[index][filed_name] = value;
    setServiceList(tempServiceList);
    // console.log(serviceList);
  };
  const handleNewBill = () => {
    getServiceListFromLocalStore();
    dispatch({
      type: "cartItems_reset",
    });
    dispatch({
      type: "orderId_remove",
    });
  };
  // Method management end
  // useEffect management
  const getServiceList = () => {
    axios
      .get("/billing-service-head")
      .then((response) => {
        // console.log("serviceList response", response);
        const serviceListWithQty = addQtyColumnInServiceList(response.data); // add qty column through map
        localStorage.setItem("serviceList", JSON.stringify(serviceListWithQty)); // stringify & set to local storage
        setServiceList(serviceListWithQty); // update state
      })
      .catch("getServiceList-error", console.log)
      .finally(console.log("request done"));
  };

  const getServiceListFromLocalStore = () => {
    const serviceListLocal = localStorage.getItem("serviceList"); // get localStorage by serviceList key
    if (serviceListLocal) {
      // service_list key exist
      setServiceList(JSON.parse(serviceListLocal)); // convert localStoreage  string value to object & update state
    } else {
      // service list key dow not exist so run axios to get data from remote host
      getServiceList();
    }
  };
  // useEffect management end

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleAdd = (item) => {
    const newItem = { ...item };
    //{id: 1, service_name: 'Service 1', mrp: 500, qty: 2},
    // console.log("handleAdd-", item);
    dispatch({
      type: "cartItems_add",
      payload: newItem,
    });
    // console.log("arr-", serviceList[item])
  };

  const addQtyColumnInServiceList = (list) => {
    list.map((item) => (item["qty"] = parseInt(1)));
    // console.log("tempRow-", list, list.length);
    // setServiceList(list);
    return list;
  };
  useEffect(() => {
    // row[0]["qty"]=1;
    // const tempRow =

    // getServiceList();
    getServiceListFromLocalStore();
  }, []);
  return (
    <>
      {/* ------------------------------------------------------------- PRICE CHART  */}
      <TableContainer component={Paper} style={{ height: 500 }}>
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell align="left">Service Name</StyledTableCell>
              <StyledTableCell align="left">Price</StyledTableCell>
              <StyledTableCell align="right">Qty</StyledTableCell>
              <StyledTableCell align="right">ADD</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serviceList.map((serviceItem, index) => (
              <TableRow
                key={serviceItem.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {serviceItem.id}
                </TableCell>
                <TableCell align="left" sx={{ py: 1 }}>
                  <TextField
                    autoComplete="off"
                    size="small"
                    value={serviceItem.service_name}
                    onChange={(e) =>
                      handleListItemChange(
                        e.target.value,
                        index,
                        "service_name"
                      )
                    }
                  />
                </TableCell>
                <TableCell align="right" sx={{ maxWidth: "150px", py: 1 }}>
                  <TextField
                    autoComplete="off"
                    size="small"
                    type="number"
                    value={parseInt(serviceItem.mrp)}
                    onChange={(e) =>
                      handleListItemChange(e.target.value, index, "mrp")
                    }
                  />
                </TableCell>
                <TableCell align="right" sx={{ maxWidth: "100px", py: 1 }}>
                  <TextField
                    autoComplete="off"
                    size="small"
                    type="number"
                    value={serviceItem.qty}
                    onChange={(e) =>
                      handleListItemChange(e.target.value, index, "qty")
                    }
                  />
                </TableCell>
                <TableCell align="right" sx={{ width: "100px", py: 1 }}>
                  <Button
                    variant="outlined"
                    onClick={() => handleAdd(serviceItem)}
                  >
                    ADD
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ mt: 2, float: "right" }}>
        <Button key="two" variant="contained" onClick={handleNewBill}>
          New Bill
        </Button>
      </Box>

      {/* ------------------------------------------------------------- PRICE CHART END */}
    </>
  );
};

export default ServicePriceList;
